module.exports = __webpack_public_path__ + "static/media/_prelude.fragment.c01b074c.glsl";